import type { KeyboardEvent } from 'react';

/** Standard horizontal tab navigation; selection follows keyboard focus. */
export function navigateTabs(event: KeyboardEvent<HTMLElement>): void {
  if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
  const tabs = Array.from(event.currentTarget.querySelectorAll<HTMLButtonElement>('[role="tab"]')).filter(tab => !tab.disabled);
  const index = tabs.findIndex(tab => tab === document.activeElement);
  if (index < 0 || !tabs.length) return;
  const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
  event.preventDefault(); event.stopPropagation();
  tabs[next].focus(); tabs[next].click();
}
